import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosMain from "../axiosMain";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ToastNotification from "./Toast/ToastNotification";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../context/DataProvider";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import companyLogo from "../assets/logo/logo.png";
import "./Login.css"
import SignUp from "./SignUp";
import { Toast } from "react-bootstrap";
import OtpVerification from "./otpVerification";
import { Phone } from "@mui/icons-material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { BASE_URLS, WINDOW_HREF } from "../utils/baseUrls";


const Login = ({ showModal, setopenModal, handleClose, onLoginSuccess, activeTab }) => {
  const { loggedUserDetail, setLoggedUserDetail, clearDataContext, setIsLoggingOut, openLoginModal, setopenLoginModal, openLoginMessage, setopenLoginMessage, setIsLoggedInTrue } = useContext(DataContext);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [openSignUpModal, setopenSignUpModal] = useState(false);
  const [showforogtModal, setshowforogtModal] = useState(false);
  const [otpshowModal, setotpshowModal] = useState(false);
  const [resotp, setresOtp] = useState(0);
  const [apiResponse, setApiResponse] = useState(null);
  const [phone, setphoneno] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false); // Success modal state
  const [submittedEmail, setSubmittedEmail] = useState("");

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter valid email")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Please enter password !"),
    }),
    onSubmit: (values) => {

      axiosMain
        .post(BASE_URLS + "/Registration/Login_new", {
          Email: values.email,
          Password: values.password,
          // Hosturl: "https://beta.tendergpt.io",
          // DomainUrl: "https://beta.tendergpt.io",
          //   Hosturl: window.location.origin,
          //   DomainUrl: window.location.origin,
        })

        ?.then((res) => {

          if (res?.data?.ConfirmationStatus === 1) {
            ToastNotification.success(res?.data?.SuccessMessage);
            setLoggedUserDetail(res?.data);
            localStorage.setItem("logDetails", JSON.stringify(res?.data));
            localStorage.setItem("token", res?.data?.Token);
            setIsLoggedInTrue(true);
            navigate("/chat");
            
            try {
              if (onLoginSuccess) {
                onLoginSuccess(activeTab);
              } else {
                handleClose();
              }
              
            } catch (error) {
              console.error("Error in onLoginSuccess:", error);
            }

            // clearDataContext();
            // navigate("/chat");
            setIsLoggingOut(true);
            handleClose(); // Close modal on successful login
            formik.resetForm();
            window.location.reload();
          }
          else if (res?.data?.ConfirmationStatus === 3) {
            ToastNotification.success(res?.data?.SuccessMessage);
            setLoggedUserDetail(res?.data);
            localStorage.setItem("logDetails", JSON.stringify(res?.data));
            localStorage.setItem("token", res?.data?.Token);

            try {
              if (onLoginSuccess) {
                onLoginSuccess(activeTab);
              } else {
                handleClose();
              }
            } catch (error) {
              console.error("Error in onLoginSuccess:", error);
            }
            // clearDataContext();
            // navigate("/chat");
            setIsLoggingOut(true);
            handleClose(); // Close modal on successful login
            formik.resetForm();
            window.location.reload();
          }
          else {
            ToastNotification.warning(res?.data?.SuccessMessage);
          }
        })
        ?.catch((err) => {
          ToastNotification.error("Login failed !!");
        });
    },
  });
  const emailValidation = Yup.string()
    // .email("Invalid email address")
    .required("Please enter your Mobile Number Or Email");


  const forgotformik = useFormik({
    initialValues: {
      forgotemail: "",
    },
    validationSchema: Yup.object({
      forgotemail: emailValidation
    }),
    onSubmit: (values) => {
      axiosMain
        .get(BASE_URLS + `/Registration/GetEmailAvailability?email=${values.forgotemail}&domainName=${WINDOW_HREF}`)

        ?.then((res) => {
          if (res?.data?.SuccessCode === 1) {
            ToastNotification.success(res?.data?.SuccessMessage);
            axiosMain.post(BASE_URLS + "/Registration/SendForgotPasswordEmail", {
              ToEmail: values.forgotemail,
              UserName: null,
              // Hosturl: "https://beta.tendergpt.io",
              UserId: 0,
              UserDetailId: 0,
              // DomainUrl: "https://beta.tendergpt.io",
            }).then((res) => {
              if (res?.data?.successCode === 1) {
                // ToastNotification.success(res?.data?.successMessage);
                setshowforogtModal(false);
                forgotformik.resetForm();
                setShowSuccessModal(true);
                setSubmittedEmail(values.forgotemail);
              }
              else if (res?.data?.successCode === 3) {
                // ToastNotification.success(res?.data?.successMessage);
                setshowforogtModal(false);
                setotpshowModal(true);

                setresOtp(res?.data?.otp);
                setApiResponse({ UserId: res?.data?.emailIds?.at(0).userId, UserDetailId: res?.data?.emailIds?.at(0).userdetailId, DomainId: res?.data?.emailIds?.at(0).udDomainId });
                setotpshowModal(true);
                setphoneno(values.forgotemail);

              }
              else {
                ToastNotification.warning(res?.data?.successMessage);
                // setShowSuccessModal(true);
                // setshowforogtModal(false);
              }
              forgotformik.resetForm();
            }).catch((exx) => {
              ToastNotification.error("SendForgotPasswordEmail Api error !")
            })
          }
          else {
            ToastNotification.warning(res?.data?.SuccessMessage);
          }
        })
        ?.catch((err) => {
          ToastNotification.error("Checking Email Availability Failed!!");
        });
    },
  });
  useEffect(() => {
    let timer;

    if (openLoginModal === true) {
      timer = setTimeout(() => {
        setopenLoginMessage('');
        // setopenLoginModal(false);
      }, 10000); // 60 seconds
    }

    // Cleanup timer on component unmount or when dependencies change
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
    // clearDataContext();
  }, [openLoginModal]);



  return (
    <>
      {/* <Modal show={showModal || openLoginModal} onHide={handleClose} centered>
        <Modal.Header>

          <div className="text-center mb-3" onClick={() => navigate("/chat")}>
            <img src={companyLogo} className="ps-3 pt-3" alt="Company Logo" />
            <p style={{ color: "red" }}>{openLoginMessage}</p>
          </div>

          <Button onClick={() => {
            handleClose();
            setopenLoginModal(false);
          }} className="modal-btn-close"><i className="fa fa-close"></i></Button>
        </Modal.Header>
        <Modal.Body style={{ background: "transperant" }}>
          <div className="LoginApp">

            <form className="form" onSubmit={formik.handleSubmit}>
              <div className="input-container mb-3">
                <input
                  placeholder="Please Enter Email"
                  type="email"
                  name="email"
                  className="form-control"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-danger">{formik.errors.email}</div>
                ) : null}
              </div>

              <div className="input-container mb-3">
                <input
                  placeholder="Please Enter Password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-danger">{formik.errors.password}</div>
                ) : null}
                <span
                  className="password-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPassword(!showPassword);
                  }}
                >
                  {showPassword ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
                </span>
              </div>
              <span onClick={() => { setshowforogtModal(true); handleClose() }}>Forgot Password ?
              </span>
              <Button variant="primary" type="submit" className="w-100" style={{ fontSize: "25px" }}>
                Login, Let's win Tenders
              </Button>

              <div className="signup-container">
                <span>New To Tender Tiger ,</span>
                <Button type="button" className="sign-up-btn" onClick={() => { setopenSignUpModal(true); handleClose(true) }}>
                  Sign up for Free
                </Button>
              </div>
            </form>
          </div>

        </Modal.Body >
        
      </Modal > */}

      <Modal className="login-modal" size="md" show={showModal || openLoginModal} onHide={handleClose} centered>
        <Modal.Header>
          <Button onClick={() => {
            handleClose();
            setopenLoginModal(false);
          }} className="modal-btn-close"><i className="fa fa-close"></i></Button>
        </Modal.Header>
        <Modal.Body style={{ background: "transparent" }}>
          <div className="LoginApp">
            <div className="modal-bx-filed-set">
              <fieldset>
                <legend>Login</legend>
                <form className="form" onSubmit={formik.handleSubmit}>
                  <div className="input-container mb-3">
                    <input
                      placeholder="Please Enter Email"
                      type="email"
                      name="email"
                      className="form-control"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="text-danger">{formik.errors.email}</div>
                    ) : null}
                  </div>
                  <div className="input-container">
                    <input
                      placeholder="Please Enter Password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <div className="text-danger">{formik.errors.password}</div>
                    ) : null}
                    <span
                      className="password-toggle"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowPassword(!showPassword);
                      }}
                    >
                      {showPassword ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
                    </span>
                  </div>
                  <div className="text-end cursor-pointer ">
                    <span onClick={() => { setshowforogtModal(true); handleClose(); formik.resetForm(); }}>Forgot Password ?</span>
                  </div>
                  <Button variant="primary" type="submit" className="w-100" style={{ fontSize: "25px" }}>
                    Login, Let's win Tenders
                  </Button>
                  <div className="signup-in-container">
                    <span>New To Tender GPT,</span>
                    <a
                      className="sign-up-in-btn"
                      onClick={() => { setopenSignUpModal(true); handleClose(true); }}
                    >
                      Sign up for Free
                    </a>
                  </div>
                </form>
              </fieldset>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <SignUp showModal={openSignUpModal} handleClose={() => setopenSignUpModal(false)} showModalLogin={() => setopenModal(true)} />
      {/* forgot password Modal*/}
      {/* <Modal show={showforogtModal} onHide={() => { setshowforogtModal(false) }} centered>
        <Modal.Header>
          <div className="text-center mb-3">
            <p>Forgot Pasword</p>
          </div>
          <Button onClick={() => { setshowforogtModal(false); forgotformik.resetForm(); }} className="modal-btn-close"><i className="fa fa-close"></i></Button>
        </Modal.Header>
        <Modal.Body style={{ background: "transperant" }}>
          <div className="LoginApp">
            <form className="form" onSubmit={forgotformik.handleSubmit}>
              <div className="input-container mb-3">
                <input
                  placeholder="Please Enter Email"
                  type="text"
                  name="forgotemail"
                  className="form-control"
                  value={forgotformik.values.forgotemail}
                  onChange={forgotformik.handleChange}
                  onBlur={forgotformik.handleBlur}
                />
                {forgotformik.touched.forgotemail && forgotformik.errors.forgotemail ? (
                  <div className="text-danger">{forgotformik.errors.forgotemail}</div>
                ) : null}
              </div>
              <Button variant="primary" type="submit" className="w-100" style={{ fontSize: "25px" }}>
                Submit
              </Button>
            </form>
          </div>
        </Modal.Body>
      </Modal> */}
      <Modal show={showforogtModal} onHide={() => { setshowforogtModal(false); }} centered>
        <Modal.Header>
          <Button onClick={() => { setshowforogtModal(false); forgotformik.resetForm(); }} className="modal-btn-close">
            <i className="fa fa-close"></i>
          </Button>
        </Modal.Header>
        <Modal.Body style={{ background: "transparent" }}>
          <div className="LoginApp">
            <div className="modal-bx-filed-set">
              <fieldset>
                <legend>Forgot Password</legend>
                <form className="form" onSubmit={forgotformik.handleSubmit}>
                  <div className="input-container mb-3">
                    <input
                      placeholder="Enter Email or Mobile Number"
                      type="text"
                      name="forgotemail"
                      className="form-control"
                      value={forgotformik.values.forgotemail}
                      onChange={forgotformik.handleChange}
                      onBlur={forgotformik.handleBlur}
                    />
                    {forgotformik.touched.forgotemail && forgotformik.errors.forgotemail ? (
                      <div className="text-danger">{forgotformik.errors.forgotemail}</div>
                    ) : null}
                  </div>
                  <Button variant="primary" type="submit" className="w-100" style={{ fontSize: "25px" }}>
                    Submit
                  </Button>
                </form>
              </fieldset>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* forgot password modal */}
      <OtpVerification otpshowModal={otpshowModal} setotpshowModal={() => setotpshowModal(false)} setresOtp={setresOtp}
        apiResponse={apiResponse} resotp={resotp} type="forgotpassword" phoneno={phone} />
      {/* Success Modal */}
      <Modal size="lg" show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Header>
          <Button onClick={() => setShowSuccessModal(false)} className="modal-btn-close">
            <i className="fa fa-close"></i>
          </Button>
        </Modal.Header>
        <Modal.Body className="text-center success-message-check-card">
          <span className="success-message-check"><CheckCircleIcon /></span>
          <p>We have sent an Password Reset link <strong>{submittedEmail} </strong> from <strong>care@tendertiger.com</strong>  <br />
            Please check your inbox,click on email verification link to reset password.</p>

        </Modal.Body>
      </Modal>
    </>
  );
};

export default Login;
